import ActionTypes from '../Actions/ActionTypes';

let initialState = {
    Gallery: [],
    SpecificCategory: [],
    categoryImages: [],
    vendorPhotos: [],

};

const InspirationalGalleryReducer = (state = initialState, action) => {

    switch (action.type) {
        case ActionTypes.GET_GALLERY:
            state = { ...state, Gallery: action.payload };
            break;

        case ActionTypes.UPDATE_GALLERY:
            let updatedGallery = [...action.payload]
            state = { ...state, Gallery: updatedGallery }
            break;


        case ActionTypes.GET_SPECIFIC_CATEGORY:
            state = { ...state, SpecificCategory: action.payload, categoryImages: action.payload?.images };
            break;

        case ActionTypes.CLEAR_SPECIFIC_CATEGORY:
            state = { ...state, SpecificCategory: [], categoryImages: [] };
            break;

        case ActionTypes.DELETE_GALLERY:
            let updatedList = [...state.categoryImages];
            let index_to_be_deleted = updatedList.findIndex((item) => item?.id == action?.payload)
            updatedList.splice(index_to_be_deleted, 1);
            state = { ...state, categoryImages: updatedList };
            break;

        case ActionTypes.GET_VENDOR_PHOTOS:
            state = { ...state, vendorPhotos: action.payload };
            break;

        default:
            break;
    }
    return state;
};

export default InspirationalGalleryReducer;